"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = exports.AnalyticsProvider = void 0;
var router_1 = require("next/router");
var react_1 = __importDefault(require("react"));
var client_provider_1 = require("./internals/client-provider");
var route_tracker_1 = require("./internals/route-tracker");
var user_tracker_1 = require("./internals/user-tracker");
/**
 * Adds the Segment client provider, tracks Next.js route changes, and identifies the current user.
 */
function AnalyticsProvider(props) {
    var children = props.children, router = props.router;
    if (router) {
        return (react_1.default.createElement(AnalyticsProviderWithRouter, __assign({}, props, { router: router }), children));
    }
    return react_1.default.createElement(LegacyAnalyticsProvider, __assign({}, props), children);
}
exports.AnalyticsProvider = AnalyticsProvider;
/**
 * This is the real analytics provider, but it's wrapped for backwards compatibility.
 */
function AnalyticsProviderWithRouter(props) {
    var children = props.children, user = props.user, apiKey = props.apiKey, router = props.router, appName = props.appName, defaultPageProperties = props.defaultPageProperties, clientOptions = __rest(props, ["children", "user", "apiKey", "router", "appName", "defaultPageProperties"]);
    return (react_1.default.createElement(client_provider_1.SegmentClientProvider, { apiKey: apiKey, clientOptions: clientOptions },
        react_1.default.createElement(user_tracker_1.UserTracker, { user: user },
            react_1.default.createElement(route_tracker_1.RouteTracker, { router: router, appName: appName, defaultPageProperties: defaultPageProperties }, children))));
}
/**
 * Wrap the real analytics provider and grab the router the way we used to.
 */
function LegacyAnalyticsProvider(props) {
    var children = props.children;
    var router = (0, router_1.useRouter)();
    return (react_1.default.createElement(AnalyticsProviderWithRouter, __assign({}, props, { router: router }), children));
}
/**
 * Access the Segment client directly.
 */
function useAnalytics() {
    var client = (0, client_provider_1.useSegmentClientContext)().client;
    return client;
}
exports.useAnalytics = useAnalytics;
